import * as React from 'react';
import toggleAEMSibling from '../../utilities/toggleAEM';

interface PanelErrorProps {
  title: string;
  body: string;
  button: JSX.Element;
}

const PanelError = ({
  title,
  body,
  button,
}: PanelErrorProps) => {
  toggleAEMSibling(true);
  return (
    <div className="panel-error">
      <h3 className="title">{title}</h3>
      <p className="body">{body}</p>
      {button}
    </div>
  );
};

export default PanelError;



// WEBPACK FOOTER //
// ./src/components/PanelError/PanelError.tsx